import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchEducation, deleteEducation } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'educationId', label: 'ID', minWidth: 50 },
  { id: 'educationName', label: 'Education Name', minWidth: 170 },
  { id: 'description', label: 'Description', minWidth: 300 },
];

const EducationList = ({ onEdit, searchQuery = '' }) => {
  const [educationList, setEducationList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadEducation = async () => {
      setLoading(true);
      try {
        const response = await fetchEducation();
        if (cancelled) return;
        setEducationList(Array.isArray(response?.data) ? response.data : []);
        setError(null);
      } catch (err) {
        console.error('Error fetching education:', err);
        if (!cancelled) {
          setError('Failed to load education. Please try again later.');
          setEducationList([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadEducation();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (education) => {
    try {
      await deleteEducation(education.educationId, {
        previousData: education,
        identifier: education.educationName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting education:', err);
      alert('Failed to delete education. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Education
      </Typography>

      <MasterDataTable
        persistKey="education"
        data={educationList}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No education found. Add your first education!"
      />

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default EducationList;
